var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIntegration = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 8,
  viewBox: "0 0 16 8",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.502 0C8.882 0 10 1.347 10 2.997V5L8 3v-.203C8 2.36 7.663 2 7.252 2H2.748c-.379 0-.692.3-.741.69L2 2.796v2.406c0 .437.337.797.748.797H5v.045c0 .669.656 1.73 1.129 1.956L2.498 8C1.118 8 0 6.653 0 5.003V2.997C0 1.342 1.118 0 2.498 0zm6 0C14.882 0 16 1.347 16 2.997v2.006C16 6.658 14.882 8 13.502 8H8.498C7.118 8 6 6.653 6 5.003V3l2 2v.203c0 .437.337.797.748.797h4.504c.379 0 .692-.3.741-.69L14 5.204V2.797C14 2.36 13.663 2 13.252 2h-2.169l.002-.034c0-.5-.747-1.755-1.19-1.969z"
})));
export default SvgIntegration;